
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6d1d68c4&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Campaign.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./Campaign.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6d1d68c4!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Campaign.vue"),
  /* scopeId */
  "data-v-6d1d68c4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Campaign/Campaign.vue
// module id = 581
// module chunks = 0